import { useEffect, useRef, useState } from "react";
import { useSearchParams } from "react-router-dom";

const PAGES = ["/", "/streamer", "/giveaway", "/classifica", "/news", "/donazione"];

// Overlay OBS: telefono che mostra il sito vero, pagina per pagina, in automatico.
// Uso OBS: Browser Source -> https://<dominio>/promo (dimensioni consigliate 480x900)
// Parametri: ?interval=15 (secondi per pagina, min 5)  ?bg=dark (sfondo scuro invece di trasparente)
export default function PromoOverlay() {
  const [params] = useSearchParams();
  const interval = Math.max(5, parseInt(params.get("interval") || "12", 10) || 12) * 1000;
  const solid = params.get("bg") === "dark";
  const [front, setFront] = useState(0);
  const [srcs, setSrcs] = useState([PAGES[0], PAGES[1]]);
  const idxRef = useRef(0);
  const frontRef = useRef(0);
  frontRef.current = front;

  useEffect(() => {
    if (solid) return;
    const appEl = document.querySelector(".App");
    const noiseEl = document.querySelector(".noise-overlay");
    const prevBody = document.body.style.background;
    const prevApp = appEl?.style.background || "";
    const prevNoise = noiseEl?.style.display || "";
    document.body.style.setProperty("background", "transparent", "important");
    document.documentElement.style.setProperty("background", "transparent", "important");
    appEl?.style.setProperty("background", "transparent", "important");
    if (noiseEl) noiseEl.style.display = "none";
    return () => {
      document.body.style.background = prevBody;
      document.documentElement.style.background = "";
      if (appEl) appEl.style.background = prevApp;
      if (noiseEl) noiseEl.style.display = prevNoise;
    };
  }, [solid]);

  useEffect(() => {
    const id = setInterval(() => {
      const nextIdx = (idxRef.current + 1) % PAGES.length;
      idxRef.current = nextIdx;
      const hidden = frontRef.current === 0 ? 1 : 0;
      // precarica la pagina nel layer nascosto, poi crossfade dopo il caricamento
      setSrcs((s) => { const c = [...s]; c[hidden] = PAGES[nextIdx]; return c; });
      setTimeout(() => setFront(hidden), 3000);
    }, interval);
    return () => clearInterval(id);
  }, [interval]);

  return (
    <div className={`min-h-screen flex flex-col items-center justify-center overflow-hidden ${solid ? "bg-[#050505]" : ""}`} data-testid="promo-overlay">
      <div className="relative rounded-[3.2rem] bg-[#0A0A0A] border border-[#242424] p-2.5 shadow-[0_0_90px_rgba(255,92,0,0.18)]" data-testid="promo-phone">
        <div className="absolute -left-[3px] top-28 w-[3px] h-14 rounded bg-[#242424]" />
        <div className="absolute -left-[3px] top-48 w-[3px] h-20 rounded bg-[#242424]" />
        <div className="absolute -right-[3px] top-36 w-[3px] h-24 rounded bg-[#242424]" />
        <div className="relative w-[380px] h-[740px] rounded-[2.5rem] overflow-hidden bg-[#050505]">
          <div className="absolute top-2.5 left-1/2 -translate-x-1/2 w-28 h-6 bg-black rounded-full z-20 pointer-events-none" />
          {[0, 1].map((layer) => (
            <iframe
              key={layer}
              src={srcs[layer]}
              title={`WARDOGS.HQ — anteprima ${layer + 1}`}
              className="absolute inset-0 w-full h-full border-0 transition-opacity duration-700"
              style={{ opacity: front === layer ? 1 : 0, pointerEvents: "none" }}
              data-testid={`promo-frame-${layer}`}
            />
          ))}
        </div>
      </div>
      <p className="mt-5 font-mono text-[10px] uppercase tracking-[0.45em] text-wardogs" data-testid="promo-caption">
        wardogsitaliangamer.it
      </p>
    </div>
  );
}
